import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toQS } from '../QSMapper';
import { FormGroup, Label, InputGroup, InputGroupAddon, InputGroupText, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaste } from '@fortawesome/pro-light-svg-icons';
import ReactGA from 'react-ga';

class ShareUrl extends Component {

    constructor(props) {
        super(props);
        this.urlField = React.createRef();
        this.selectUrl = this.selectUrl.bind(this);
        this.copyToClipboard = this.copyToClipboard.bind(this);
    }

    selectUrl() {
        this.urlField.current.select();
    }

    copyToClipboard = (event) => {
        this.selectUrl();
        document.execCommand("copy");

        // Log to analytics
        ReactGA.event({
            category: 'Sharing',
            action: 'Link copied to clipboard'
        });
    }


    render() {
        const qs = toQS(this.props.property);
        const url = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + qs;

        return (
            <Card id="share-url-outer">
                <CardBody>
                    <FormGroup>
                        <Label htmlFor='shareUrl'>Share this calculation:</Label>
                        <InputGroup>
                            <input type="text" className='form-control' name='shareUrl' value={url} ref={this.urlField} readOnly onFocus={this.selectUrl} />
                            <InputGroupAddon addonType="append" onClick={this.copyToClipboard} >
                                <InputGroupText><FontAwesomeIcon icon={faPaste} /></InputGroupText>
                            </InputGroupAddon>
                        </InputGroup>
                    </FormGroup>
                </CardBody>
            </Card>
        )
    }
}

const mapStateToProps = state => {
    return { property: state.property };
};

export default connect(mapStateToProps)(ShareUrl);


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/Components/ShareUrl.jsx